import Vue from 'vue';
import {
    MASTER
} from '@/constants/funcionarioCargo.js';

import Auth from '@/store/auth';

import {
    isMultiEmpresa
}
from '@/environment';



const checaCargo = (cargosMono = [], cargosMulti = []) => {

    const CARGO_LOGADO = Auth.getCargoUsuario();

    if (CARGO_LOGADO == MASTER) {
        return true;
    } else if (isMultiEmpresa) {
        return cargosMulti.includes(CARGO_LOGADO) || cargosMulti.length === 0
    } else {
        return cargosMono.includes(CARGO_LOGADO) || cargosMono.length === 0
    }
}
export {
    checaCargo
}


// WEBPACK FOOTER //
// ./src/helpers/perfil.js